
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-details/[companyslug]",
      function () {
        return require("private-next-pages/job-details/[companyslug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-details/[companyslug]"])
      });
    }
  